import Logger from 'core/utils/Logger'
import { ActualsValueTypes } from 'partner360/models/actualValueTypes'

export interface IParsedEltDocumentSettings {
  netNdp?: ActualsValueTypes
}

interface IEltDocumentSettingsJson {
  NetNdp?: unknown
}

const ACTUALS_VALUE_TYPES = new Set<string>(Object.values(ActualsValueTypes))

export const parseEltDocumentSettings = (
  settings: string | null | undefined
): IParsedEltDocumentSettings => {
  if (!settings) {
    return {}
  }

  try {
    const parsed: unknown = JSON.parse(settings)

    if (typeof parsed !== 'object' || parsed === null) {
      return {}
    }

    const { NetNdp } = parsed as IEltDocumentSettingsJson

    return {
      netNdp:
        typeof NetNdp === 'string' && ACTUALS_VALUE_TYPES.has(NetNdp)
          ? (NetNdp as ActualsValueTypes)
          : undefined,
    }
  } catch (e) {
    Logger.error(`IFinancialCockpitEltDocument.Settings: ${e}`)
    return {}
  }
}
